import { useState } from "react";
import { EyeMark } from "./Logo";
import LinkRecovery from "./LinkRecovery";

const Footer = () => {
  const [recoveryOpen, setRecoveryOpen] = useState(false);
  return (
    <footer className="border-t border-[#D4AF37]/10 py-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <EyeMark className="w-7 h-7" />
          <div>
            <p className="font-display text-xs font-bold tracking-[0.2em] text-[#F8FAFC]">THE END OF THE OBVIOUS</p>
            <p className="font-mono-alt text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]/60">From the Archives of the Gg Elves</p>
          </div>
        </div>
        <div className="flex flex-col items-center sm:items-end gap-2">
          <div className="flex flex-wrap justify-center gap-x-5 gap-y-1 text-xs">
            <a href="/policies#privacy" className="text-[#94A3B8] hover:text-[#FCD34D] transition-colors" data-testid="footer-privacy-link">Privacy</a>
            <a href="/policies#terms" className="text-[#94A3B8] hover:text-[#FCD34D] transition-colors" data-testid="footer-terms-link">Terms</a>
            <a href="/policies#refunds" className="text-[#94A3B8] hover:text-[#FCD34D] transition-colors" data-testid="footer-refunds-link">Refunds & Delivery</a>
            <a href="/policies#contact" className="text-[#94A3B8] hover:text-[#FCD34D] transition-colors" data-testid="footer-contact-link">Contact</a>
          </div>
          <button
            data-testid="link-recovery-open-button"
            onClick={() => setRecoveryOpen(true)}
            className="text-xs text-[#FCD34D] underline underline-offset-4 hover:text-[#D4AF37] transition-colors focus:outline-none focus:ring-2 focus:ring-[#D4AF37] rounded"
          >
            Lost your download link?
          </button>
          <p className="text-xs text-[#94A3B8] text-center sm:text-right">
            © {new Date().getFullYear()} The Gg Elves Archive. The Archive remains open.
          </p>
        </div>
      </div>
      <LinkRecovery open={recoveryOpen} onClose={() => setRecoveryOpen(false)} />
    </footer>
  );
};

export default Footer;
